import React from 'react';
import './services.css';
import { Helmet } from "react-helmet";

import whatsapp from '../../Assets/whatsapp.png';
import call from '../../Assets/call.png';
import ChestSurfacePiercingImage from '../../Assets/Piercing Services/chest surface piercing (2).png';
import Footer from '../contactus/contactus';

const handleWhatsAppClick = (message) => {
  const url = `https://wa.me/971567257579?text=${encodeURIComponent(message)}`;
  window.open(url, "_blank");
};

function ChestSurfacePiercing() {
  return (
    <div>
      <div className="earlobe-container">
        <Helmet>
          <title>Chest Surface Piercing UAE | 400-500 AED</title>
        </Helmet>

        <div className="floating-buttons">
          <div
            className='whatsapp-button'
            onClick={() => handleWhatsAppClick("I am interested in Chest Surface Piercing")}
          >
            <img src={whatsapp} alt="WhatsApp" />
          </div>

          <a href="tel:+971567257579" className="call-button">
            <img src={call} alt="Call" />
          </a>
        </div>

        <h1 className="earlobe-title">
          Chest Surface Piercing 400-500 AED
        </h1>

        <div className="earlobe-image-wrapper">
          <img src={ChestSurfacePiercingImage} alt="Chest Surface Piercing" />
        </div>

        <div className="earlobe-content">
          <h3>Chest Surface Piercing</h3>

          <p>
            Enhance your body style with our professional chest surface piercing services in the UAE, available at an affordable price range of 400–500 AED. Chest surface piercing is a decorative and modern body piercing that sits on the surface of the skin, creating a bold and stylish look that allows for creative jewelry placement. Unlike traditional piercings, this technique uses specially designed surface bars that rest beneath the skin while displaying two visible ends, giving the illusion of floating jewelry on the chest. This unique aesthetic makes chest surface piercing a popular choice for individuals who want to express their personality with a distinctive and fashion-forward appearance.
          </p>

          <p>
            At our piercing studio, safety, hygiene, and precision are our highest priorities. Our certified professionals use sterile, single-use, high-quality equipment to perform each chest surface piercing with exceptional care and accuracy. We strictly follow professional hygiene protocols to maintain a clean and sanitized environment, minimizing the risk of infection and ensuring a safe and smooth experience. Surface piercings require advanced expertise due to their placement, and our experienced specialists are trained to ensure proper alignment, depth, and positioning for the best possible results while minimizing discomfort.
          </p>

          <p>
            Chest surface piercing is ideal for those who want a bold and customizable body modification. Its placement offers flexibility, allowing you to choose from a variety of jewelry styles, including sleek bars, decorative ends, or gemstone pieces that enhance your overall look. Whether you prefer a subtle design or a more dramatic statement, this piercing can be tailored to suit your personal style. Our specialists take the time to understand your preferences and guide you in selecting the best placement and jewelry options to complement your body structure and aesthetic goals.
          </p>

          <p>
            The procedure is typically quick and efficient, making it convenient even for clients with busy schedules. Our team uses advanced techniques designed to reduce discomfort and support effective healing, ensuring that you can enjoy your new piercing with confidence. We also provide high-quality, hypoallergenic surface jewelry that is safe for sensitive skin, helping to prevent irritation and ensuring a smooth healing process.
          </p>

          <p>
            Our clean, welcoming, and professional environment ensures that every client feels comfortable and confident throughout their visit. We understand that surface piercings can feel intimidating, especially for first-time clients, and our friendly and experienced staff is always available to answer your questions and provide reassurance. From consultation to completion, we focus on delivering a smooth and positive experience tailored to your needs.
          </p>

          <p>
            Aftercare is especially important for chest surface piercings, and we provide detailed instructions to help you maintain proper care during the healing process. Our specialists will guide you on cleaning routines, recommended products, and precautions to avoid infection, irritation, or movement of the jewelry. Following proper aftercare is essential for maintaining the longevity and appearance of your piercing.
          </p>

          <p>
            Our chest surface piercing services in the UAE combine premium quality with transparent pricing, ensuring you receive excellent value without hidden costs. Booking your appointment is quick and convenient, allowing you to choose a time that fits your schedule. We aim to provide minimal waiting time and a seamless experience from start to finish.
          </p>

          <p>
            Choose our trusted chest surface piercing services in the UAE for a safe, hygienic, and professional experience. With skilled specialists, precise techniques, and a strong commitment to customer satisfaction, we help you achieve a bold and creative body look effortlessly. Book your chest surface piercing appointment today and elevate your style with confidence and expert care.
          </p>

          <button
            className="book-btn"
            onClick={() => handleWhatsAppClick("I want to book Chest Surface Piercing")}
          >
            Book Now
          </button>
        </div>
      </div>
      <Footer />
    </div>
  );
}

export default ChestSurfacePiercing;